import {
  FlatList,
  ListRenderItemInfo,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, {useEffect, useState} from 'react';
import {useTheme} from 'contexts/ThemeContext';
import {StudentType} from 'services/API/ClassApi/ClassApiModels';
import styleSheet from './styles';

export interface StudentListProps {
  data?: StudentType[];
  itemContainerStyle?: object;
  textStyle?: object;
  containerStyle?: object;
  contentContainerStyle?: object;
  flatListStyle?: object;
  itemSeparatorStyle?: object;
  onPress?(email: string): void;
  disabled?: boolean;
}

const StudentList = (props: StudentListProps) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  const [selectedId, setSelectedId] = useState('');

  useEffect(() => {
    if (Platform.OS !== 'web') {
      const initialID = props.data![0]?.email;
      setSelectedId(initialID);
    }
  }, []);

  const onPressItem = (value: string) => {
    props.onPress ? props.onPress(value) : null;

    setSelectedId(value);
  };

  const renderItem = ({item, index}: ListRenderItemInfo<StudentType>) => {
    const isSelected =
      item?.email === selectedId && !props.disabled && Platform.OS !== 'web';
    const disabled = Platform.OS === 'web' || props.disabled;

    return (
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={() => onPressItem(item?.email)}
        disabled={disabled}
        style={[
          styles.defaultItemContainerStyle,
          props.itemContainerStyle,
          styles.backgroundColor(isSelected),
        ]}>
        <Text
          style={[
            styles.defaultTextStyle,
            props.textStyle,
          ]}>{`${item?.firstname} ${item?.lastname}`}</Text>
      </TouchableOpacity>
    );
  };

  const ItemSeparatorComponent = () => {
    return (
      <View style={[styles.defaultItemSeparator, props.itemSeparatorStyle]} />
    );
  };

  return (
    <View style={[styles.defaultContainerStyle, props.containerStyle]}>
      <View
        style={[styles.defaultContentContainer, props.contentContainerStyle]}>
        <FlatList
          data={props.data}
          renderItem={renderItem}
          ItemSeparatorComponent={ItemSeparatorComponent}
          style={[styles.defaultFlatListStyle, props.flatListStyle]}
        />
      </View>
    </View>
  );
};

export default StudentList;
